import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=01a5b8f2&scoped=true"
import script from "./SettingsModal.vue?vue&type=script&lang=js"
export * from "./SettingsModal.vue?vue&type=script&lang=js"
import style0 from "./SettingsModal.vue?vue&type=style&index=0&id=01a5b8f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a5b8f2",
  null
  
)

export default component.exports